import { PermissionsEnum } from "@/auth/interfaces";
import CustomSearchFilterSupervisorVenta from "@/erp/sale/asesor/prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import {
  BucketAwtENUM,
  EstadoPreventaEnum,
  hasPermission, ModulosEnumChoice,
  TABLE_CONSTANTS,
  texto,
  useTableFilter, useTableServerSideFiltering,
  useUploadFile
} from "@/shared";
import { useUpdateContrato } from "@/shared/actions/erp";
import { GeneralTable, useModalMotivoRechazo } from "@/shared/components/ui";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { Grid, IconButton, Tooltip } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState } from "react";
import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import { useUiStore } from "@/store/ui";
import { useFetchPutPreventaPymes, useGetPreventasPymes } from "@/shared/actions/erp/preventa_pymes/preventa_pymes.action";
import { useTableColumnsPreventaPymes } from "@/erp/venta_pymes/preventa/shared/hook/useTableColumnsPreventaPymes";
import UpdateIcon from '@mui/icons-material/Update';
import { IPreventaPymes } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";

interface TablePreventaPymesProps {
  estado_preventa: EstadoPreventaEnum
  enable_action?: boolean
  pre_requiere_contrato_fisico?: boolean
}

export default function TablePreventaGestionVentaPymes({
  estado_preventa,
  enable_action = true,
  pre_requiere_contrato_fisico = false,
}: TablePreventaPymesProps) {

  const [openModal, setOpenModal] = useState(false);
  const [contratoFile, setContratoFile] = useState<File | null>(null);
  const [dataPreventa, setDataPreventa] = useState<IPreventaPymes | null>(null);

  const {
    mutateAsync: mutateAsyncPutPreventa
  } = useFetchPutPreventaPymes({})

  const {
    mutateAsync: mutateAsyncPutContrato
  } = useUpdateContrato({})

  const {
    handleUploadFile
  } = useUploadFile();

  const setAlert = useUiStore(s => s.setAlert)

  ///* Hook
  const { columnsPreventaGestionVenta } = useTableColumnsPreventaPymes(estado_preventa);

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREVENTA_PYMES
  })

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetPreventasPymes(
      {
        estado_preventa: estado_preventa,
        es_pyme: true,
        pre_requiere_contrato_fisico,
        //requiere_contrato_fisico: false,
        identificacion: searchTerm,
        page: pageIndex + 1,
        page_size: pageSize,
        fecha_preventa_before: dateBefore,
        fecha_preventa_after: dateAfter,
        user_create: vendedor,
        ...filterObject,
        filterByState: false
      }
    );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}

            setVendedor={setVendedor}
          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaPymes>
            columns={columnsPreventaGestionVenta}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // // actions
            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableEditing={enable_action}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            showCustomActionBtnSpace={enable_action}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>

                    <Grid item >
                      <Tooltip placement='top' title='Cargar contrato'>
                        <IconButton
                          onClick={() => {
                            setOpenModal(true)
                            setDataPreventa(value)
                          }}
                        >
                          <UpdateIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    {
                      hasPermission(PermissionsEnum.api_change_preventapymes) && (
                        <>
                          <Grid item>
                            <Tooltip title={texto.cancelado} placement="top">
                              <IconButton
                                onClick={() => {
                                  useHookModalMotivoRechazo.setDialogContentText(`Estás a punto de cancelar una Preventa del cliente ${value.prospecto_pymes_data.razon_social} con identificación ${value.prospecto_pymes_data.identificacion}. ¿Estás seguro? Este cambio es irreversible.`)
                                  useHookModalMotivoRechazo.setModalCancelar(true)
                                  useHookModalMotivoRechazo.reset({
                                    id: value.id_preventa_pymes,
                                    identificacion: value.prospecto_pymes_data.identificacion,
                                    razon_social: value.prospecto_pymes_data.razon_social,
                                    observaciones: value.observaciones
                                  })
                                }
                                }
                              >
                                <HighlightOffIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>

                        </>
                      )
                    }
                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />

      <ScrollableDialogProps
        onCloseIcon={() => setOpenModal(false)}
        open={openModal}
        title="Cargar documento"
        dialogContentText={`Por favor, suba el contrato firmado por el representante legal o la persona autorizada. Una vez cargado, el departamento correspondiente revisará el documento. Le recomendamos mantenerse atento a cualquier notificación.`}
        showConfirmBtn={true}
        confirmVariantBtn={'contained'}
        onClose={() => {
          setOpenModal(false)
        }}
        onConfirm={async () => {

          if (!contratoFile)
            return setAlert(true, 'Subir contrato.', AlertSeverityEnum.info);

          if (!dataPreventa)
            return setAlert(true, 'No se encontro preventa.', AlertSeverityEnum.info);

          if (!dataPreventa.contrato_data)
            return setAlert(true, 'No se encontro contrato.', AlertSeverityEnum.info);

          setOpenModal(false)


          await mutateAsyncPutPreventa({
            id: dataPreventa.id_preventa_pymes!,
            data: {
              pre_requiere_contrato_fisico: false,
              requiere_contrato_fisico: true,
              estado_preventa: EstadoPreventaEnum.PENDIENTE_DOCUMENTOS
            }
          })

          const contratoFisico = await handleUploadFile(contratoFile, BucketAwtENUM.CONTRATO_FISICO)

          await mutateAsyncPutContrato({
            id: dataPreventa.contrato_data?.id_contrato!,
            data: {
              url_contrato: contratoFisico.url,
            }
          })


        }}
        confirmTextBtn={'Guardar'}
        contentNode={
          <>
            <CargarDocumentoSoluccionCosteada
              idInput='documento-preventa'
              buttonText={'Contrato firmado'}
              selectedImage={contratoFile}
              setSelectedImage={setContratoFile}
            />
          </>
        }
      />
    </>
  )

}